import React, { useContext } from 'react';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import Details from '../../DeviationViews/Details';
import TextualContent from '../../DeviationViews/TextualContent';
import DesktopLayout from '../_partials/DesktopLayout';
import StageBackground from '../../DeviationBackground/StageBackground';
import PanelPopup from '../_partials/PanelPopup';
import { ScreenSizeContext } from '../../Measured';
import s from './DesktopTierPage.scss';
var DesktopTierPage = function (_a) {
    var deviation = _a.deviation;
    var screenSize = useContext(ScreenSizeContext).width;
    return (React.createElement(DesktopLayout, { deviation: deviation, stageContent: React.createElement(React.Fragment, null,
            React.createElement(ArtStage, { deviation: deviation, className: s['art-stage'] }),
            React.createElement(ActionBar, { deviation: deviation }),
            React.createElement(PanelPopup, { deviation: deviation, className: s['large-popover'], actionBarType: "primary" }),
            React.createElement("div", { className: s['content'] },
                React.createElement(TextualContent, { deviation: deviation }))), metaContent: React.createElement(Details, { className: s['content'], deviation: deviation }), backgroundContent: React.createElement(StageBackground, { deviation: deviation, width: Math.max(screenSize, 780) }) }));
};
DesktopTierPage.displayName = 'DesktopTierPage';
export default DesktopTierPage;
//# sourceMappingURL=DesktopTierPage.js.map